module.exports = __webpack_public_path__ + "img/主页图片4.63b95376.png";